import { ElementPosition } from "@/types";

interface SearchResultHolderProps {
    children: React.ReactNode;
    inputRef: ElementPosition;
    resultsRef: React.RefObject<HTMLDivElement | null>;
    inline?: boolean;
}

const SearchResultHolder: React.FC<SearchResultHolderProps> = ({ children, inputRef, resultsRef, inline = false }) => {
        return (
            <div
                style={inline ? {} : {
                    position: 'fixed',
                    top: inputRef.top,
                    left: inputRef.left,
                    width: inputRef.width,
                    zIndex: 10
                }}
                className="z-100 bg-white border border-gray-500 rounded-b-md shadow-md flex flex-col gap-4 overflow-hidden"
                ref={resultsRef}
            >{children}</div>
        )
}

export default SearchResultHolder;

